export const CategoryStatus = {
	COMPLETED: 'completed',
	LOCKED: 'locked',
	OPEN: 'open',
	ONGOING: 'ongoing',
};
